import React from "react";
import { Container, Row, Col } from "reactstrap";

import courseImg01 from "../../assests/images/web-development.png";
import courseImg02 from "../../assests/images/kids-learning.png";
import courseImg03 from "../../assests/images/seo.png";
import courseImg04 from "../../assests/images/ui-ux.png";
import courseImg05 from "../../assests/images/backend-prog.png";
import FreeCourseCard from "./FreeCourseCard";

import gifImage01 from "../../assests/images/.gif/header.gif";
import gifImage02 from "../../assests/images/.gif/python.gif";
import gifImage03 from "../../assests/images/.gif/8gCl.gif";
import gifImage04 from "../../assests/images/.gif/header.gif";

import "./free-course.css";

const freeCourseData = [
  {
    id: "01",
    title: "Python + DjanGo",
    imgUrl: gifImage01,
    students: ``,
    rating: ``,
  },
  {
    id: "02",
    title: "C/C++ & JavaScript",
    imgUrl: courseImg01,
    students: ``,
    rating: ``,
  },

  {
    id: "03",
    title: "HTML/CSS + ReactJS",
    imgUrl: gifImage03,
    students: ``,
    rating: ``,
  },

  {
    id: "04",
    title: ".NET + DOT.NET + ASP.NET",
    imgUrl: courseImg05,
    students: ``,
    rating: ``,
  },
];

const FreeCourse = () => {
  return (
    <section>
      <Container>
        <Row>
          <Col lg="12" className="text-center mb-5">
            <h2 className="fw-bold">Тест тапсырмалары</h2>
          </Col>

          {freeCourseData.map((item) => (
            <Col lg="3" md="4" className="mb-4" key={item.id}>
              <FreeCourseCard item={item} />
            </Col>
          ))}
        </Row>
      </Container>
    </section>
  );
};

export default FreeCourse;
